var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphic3PointsPer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 48,
    viewBox: "0 0 115 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19z",
    id: "e610pe29ca"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "tsn28qud4b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e610pe29ca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#E10A0A",
    strokeWidth: 3,
    cx: 24,
    cy: 24,
    r: 22.5
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#E10A0A",
    mask: "url(#tsn28qud4b)",
    strokeWidth: 6,
    strokeDasharray: 4,
    xlinkHref: "#e610pe29ca"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Spartan-Bold, Spartan",
    fontSize: 17,
    fontWeight: "bold",
    letterSpacing: -0.212,
    fill: "#E10A0A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.885,
    y: 31
  }, "\xA31")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Spartan-Bold, Spartan",
    fontSize: 20,
    fontWeight: "bold",
    letterSpacing: -0.25,
    fill: "#E10A0A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 51,
    y: 31
  }, "=")), /*#__PURE__*/React.createElement("path", {
    d: "M114.007 8.182c-1.619-3.988-5.095-6.64-10.335-7.884-1.052-.2-2.121-.3-3.192-.298C94.568 0 87.845 2.876 81.55 8.1a48.387 48.387 0 0 0-7.733 8.115c-2.225 2.974-3.979 6.104-5.071 9.052-2.496 6.172-2.305 12.682.5 16.986 2.34 3.59 6.388 5.578 11.708 5.748h.003c5.01-.013 10.548-1.976 16.015-5.68 5.136-3.48 9.727-8.212 12.927-13.322 2.206-3.466 3.783-7.141 4.56-10.63.852-3.833.696-7.355-.452-10.186zm-.73 6.829c-.383 2.624-1.253 5.4-2.59 8.25-2.8 5.975-7.312 11.566-12.705 15.744-6.506 5.013-12.715 7.555-18.454 7.555l-.25-.001c-4.33-.08-7.442-1.51-9.25-4.25-2.422-3.675-2.271-9.565.414-16.16 2.107-5.225 6.458-11.165 11.354-15.504 3.076-2.724 6.574-5.032 10.116-6.674 3.702-1.715 7.302-2.622 10.411-2.622h.111c5.412.086 9.015 2.358 10.418 6.57.673 2.021.816 4.406.424 7.092h.001z",
    fill: "#E10A0A"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Spartan-ExtraBold, Spartan",
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: -0.25,
    fill: "#E10A0A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 84,
    y: 32
  }, "3")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic3PointsPer);
export default __webpack_public_path__ + "static/media/graphic-3-points-per.8ad0705d455145ebc57d1cd956f8a378.svg";
export { ForwardRef as ReactComponent };